module.exports = __webpack_public_path__ + "img/06_maska_romb_1.0fe1fb4.svg";